init_radio_block = ->
  $("[data-radio-block ]").each ->
    inited = "data-inited"
    self = $(this)
    input = self.find("[data-input]")
    buttons = self.find("[data-value]")
    unless self.attr(inited)
      buttons.on "click", ->
        buttons.removeClass "active"
        btn = $(this)
        result = btn.data "value"
        input.attr "value", result
        return

      current_value = input.val()
      buttons.removeClass "active"
      buttons.each ->
        btn = $(this)
        value = btn.data "value"
        btn.addClass "active" if current_value is value
        return

      self.attr inited, true
    return

  return

$ ->
  init_radio_block()